module.exports = __webpack_public_path__ + "stylesheets/wave-trail_2384150959ed5017888c3f1008100d3b.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-trail.less
// module id = omcN
// module chunks = 51